const distributorInfoReducer =(state=null, action)=>{
    switch(action.type){
      case "GET_DISTRIBUTOR_INFO":
          return state;
      case "SET_DISTRIBUTOR_INFO" :
          return action.info;
      case "NULL_DISTRIBUTOR_INFO" :
          return action.info;
      default:
          return state;
    }
  }
  export default distributorInfoReducer
